import axios from "axios";

const apiHandler = (token? : string) => {
  const axiosInstance = axios.create();

  axiosInstance.interceptors.request.use(
    function (config) {
      config.headers['Authorization'] = `Bearer ${token}`;
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  return axiosInstance;
}



export default apiHandler;
